import React, { PropsWithChildren } from "react";

import { View, ScrollView } from "react-native";
import { Button, ConfirmAlert, DeleteAlertComponent } from "components";

import { sizes, colors } from "assets/constants";

import { useFlag } from "hooks";

import { mq, sn } from "utils";
import css from "styles";

export default function DetailsTemplate(
  props: PropsWithChildren<{
    submitLabel: string;
    submitLoading: boolean;
    onSubmit: () => void;
    hideSubmit?: boolean;

    deletable: boolean;
    deleteLoading: boolean;
    deleteDescription?: Array<{ b?: boolean; text: string }>;
    onDelete: (close: () => void) => void;

    preventChange?: boolean;
  }>
) {
  const {
    onSubmit,
    submitLabel,
    submitLoading,
    hideSubmit,

    onDelete,
    deletable,
    deleteLoading,
    deleteDescription,

    preventChange,
  } = props;

  const { flg: alert, on: showAlert, off: hideAlert } = useFlag();

  const renderContent = () => {
    return (
      <>
        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            ...css.paddingH,
            ...css.growContainer,
            paddingBottom: mq(75),
            paddingTop: sizes.space,
          }}
        >
          {props.children}
        </ScrollView>
        {!preventChange && (
          <View
            style={{
              ...css.paddingH,
              ...css.rowCenterAlign,
              marginBottom: sizes.space,
            }}
          >
            <View
              style={{
                ...css.container,
                maxWidth: sn("100%", "100%", 300, 300),
              }}
            >
              {!hideSubmit && (
                <Button
                  loading={submitLoading}
                  style={css.selfCenter}
                  title={{ value: submitLabel }}
                  onPress={onSubmit}
                />
              )}
            </View>
            {deletable && (
              <View>
                <Button
                  onPress={showAlert}
                  square={mq(45)}
                  bgColor={colors.danger}
                  icon={{ name: "trash-2", size: 25 }}
                  style={{ ...css.selfCenter, marginLeft: sizes.space }}
                />
              </View>
            )}
          </View>
        )}
      </>
    );
  };

  return (
    <>
      {renderContent()}
      <ConfirmAlert
        force
        show={alert}
        hide={hideAlert}
        renderContent={(close) => (
          <DeleteAlertComponent
            description={deleteDescription}
            removeLoading={deleteLoading}
            remove={() => onDelete(close)}
            cancel={close}
          />
        )}
      />
    </>
  );
}
